import * as FEATURES from '../../../../lib/utils/featureEligibilityConstants'
import serverProps from './serverProps'
import BlankPage from '../../react-components/blank-page-placeholder'
import content from 'pp-react-l10n'
import _ from 'lodash'
const i18n = content('transfer/page/recipient')

const SEND_TAB_FEATURES = [FEATURES.SEND, FEATURES.BUY]
const REQUEST_TAB_FEATURES = [FEATURES.REQUEST]
export const MORE_TAB_FEATURES = [
  FEATURES.GIFT,
  FEATURES.INVOICE,
  FEATURES.MASS_PAYMENT,
  FEATURES.POOLS,
  FEATURES.MGM,
  FEATURES.PPME,
  FEATURES.XB,
  FEATURES.MESSAGES,
]

const serverPropsfeatureEligibility =
  (serverProps && serverProps.featureEligibility) || {}

function filterTabs(panes, featureEligibility) {
  const filteredTabs = panes
    .map(pane => checkTabEligibility(pane, featureEligibility))
    .filter(pane => pane.eligible)

  return filteredTabs
}

/**
 * Decide the tab to render for `/myaccount/transfer/homepage`
 * Mostly, it should default to the first tab (send)
 * In case of secondary user when he does not have privilege of send,
 * render the next privileged tab
 * So it should return the first tab that user has both eligibility and privilege
 */
function getDefaultTab(panes) {
  const index = _.findIndex(panes, pane => pane.eligible && pane.privileged)
  return index < 0 ? 0 : index
}

function checkTabEligibility(pane, featureEligibility) {
  let paneAttr = { eligible: true, privileged: true, extra: {} }
  switch (pane.type.feature) {
    case 'send':
      paneAttr = checkSendRequestTabEligibility(
        SEND_TAB_FEATURES,
        featureEligibility
      )
      break
    case 'request':
      paneAttr = checkSendRequestTabEligibility(
        REQUEST_TAB_FEATURES,
        featureEligibility
      )
      break
    case 'contacts':
      paneAttr = checkContactsTabEligibility(
        SEND_TAB_FEATURES,
        REQUEST_TAB_FEATURES,
        featureEligibility
      )
      break
    case 'more':
      paneAttr = checkMoreTabEligibility(MORE_TAB_FEATURES, featureEligibility)
      break
    default:
      break
  }
  const { eligible, privileged, extra } = paneAttr
  return { ...pane, eligible, privileged, ...extra }
}

function checkSendRequestTabEligibility(tabFeatures, featureEligibility) {
  let privileged = true,
    extra = {}
  const eligible = tabFeatures.some(f => featureEligibility[f].eligible)
  if (eligible) {
    privileged = tabFeatures.some(f => featureEligibility[f].privileged)
    if (!privileged) {
      extra = {
        comp: BlankPage,
        message: i18n('homepage.blank'),
      }
    }
  }
  return { eligible, privileged, extra }
}

// show contacts tab only when user has eligibility and privilege of both send and request
function checkContactsTabEligibility(
  sendTabFeatures = SEND_TAB_FEATURES,
  requestTabFeatures = REQUEST_TAB_FEATURES,
  featureEligibility = serverPropsfeatureEligibility
) {
  const privileged = true,
    extra = {}
  const eligible =
    !_.isEmpty(featureEligibility) &&
    sendTabFeatures.some(
      f => featureEligibility[f].eligible && featureEligibility[f].privileged
    ) &&
    requestTabFeatures.some(
      f => featureEligibility[f].eligible && featureEligibility[f].privileged
    )
  return { eligible, privileged, extra }
}

function checkMoreTabEligibility(tabFeatures, featureEligibility) {
  const privileged = true,
    extra = {}
  const eligible = tabFeatures.some(
    f => featureEligibility[f].eligible && featureEligibility[f].privileged
  )
  return { eligible, privileged, extra }
}

export { filterTabs, getDefaultTab, checkContactsTabEligibility }
